import { render, staticRenderFns } from "./ShopTheLookBrowser.vue?vue&type=template&id=f1f4de6e"
import script from "./ShopTheLookBrowser.vue?vue&type=script&lang=js"
export * from "./ShopTheLookBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports